var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.9947 1.24266C27.6516 -0.414221 30.3378 -0.414221 31.9947 1.24266L33.7573 3.00526C35.4142 4.66214 35.4142 7.34846 33.7573 9.00533L19.6565 23.1061C19.3888 23.3739 19.0414 23.5477 18.6665 23.6012L12.4975 24.4825C11.9522 24.5604 11.4021 24.377 11.0126 23.9874C10.6231 23.5979 10.4397 23.0479 10.5176 22.5026L11.3989 16.3335C11.4525 15.9586 11.6261 15.6112 11.8939 15.3435L25.9947 1.24266Z",
    fill: "#00A651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.5 8.75C3.5 7.78351 4.28351 7 5.25 7H15.75C16.7165 7 17.5 6.21649 17.5 5.25C17.5 4.28351 16.7165 3.5 15.75 3.5H5.25C2.35051 3.5 0 5.85051 0 8.75V29.75C0 32.6496 2.35051 35 5.25 35H26.25C29.1496 35 31.5 32.6496 31.5 29.75V19.25C31.5 18.2835 30.7165 17.5 29.75 17.5C28.7835 17.5 28 18.2835 28 19.25V29.75C28 30.7165 27.2165 31.5 26.25 31.5H5.25C4.28351 31.5 3.5 30.7165 3.5 29.75V8.75Z",
    fill: "#00A651"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.e5f0570039bf9858f9d342913f37bcce.svg";
export { ForwardRef as ReactComponent };